import { useQuery } from "react-query"
import { Stats } from "../api/stats"
import { options } from "@fullcalendar/core/preact"

export const useDashboardStats = ({ enabled = false, options = [] }: { enabled: boolean, options: string[] }) => {

    const queryDistance = useQuery(['count_distance',JSON.stringify(options)], () => Stats.getDistanceCount(options), {
        enabled
    })

    const queryTime = useQuery(['count_time',JSON.stringify(options)], () => Stats.geteTimeCount(options), {
        enabled
    })

    const queryHorse = useQuery(['count_horses',JSON.stringify(options)], () => Stats.getHorsesCount(options), {
        enabled
    })

    const queryTrainings = useQuery(['count_trainings',JSON.stringify(options)], () => Stats.getTrainingsCount(options), {
        enabled
    })
    return {
        distanceData:queryDistance.data?.data,
        distanceLoading:queryDistance.isLoading,
        timeData:queryTime.data?.data,
        timeLoading:queryTime.isLoading,
        horseData:queryHorse.data?.data,
        horseLoading:queryHorse.isLoading,
        trainingsData:queryTrainings.data?.data,
        trainingsLoading:queryTrainings.isLoading,
    }
}